var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingCartLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18.439,
    viewBox: "0 0 20 18.439",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shopping-cart",
    transform: "translate(-0.15 -0.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2756",
    "data-name": "Group 2756",
    transform: "translate(0.15 0.15)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 1.688,
    cy: 1.688,
    r: 1.688,
    transform: "translate(6.624 15.063)",
    fill: "#95a7c6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 1.688,
    cy: 1.688,
    r: 1.688,
    transform: "translate(14.219 15.063)",
    fill: "#95a7c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2087",
    "data-name": "Path 2087",
    d: "M16.428,14.243H8.2a2.4,2.4,0,0,1-2.4-1.936L4.391,5.26q-.008-.032-.013-.064L3.655,1.585H.867A.717.717,0,0,1,.867.15H4.243a.717.717,0,0,1,.7.577l.729,3.643H19.433a.717.717,0,0,1,.7.852l-1.35,7.08v.005A2.4,2.4,0,0,1,16.428,14.243ZM8.192,12.808h8.235a.969.969,0,0,0,.951-.779L18.566,5.8H5.962l1.245,6.222a.97.97,0,0,0,.971.782Z",
    transform: "translate(-0.15 -0.15)",
    fill: "#95a7c6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCartLight);
export default __webpack_public_path__ + "static/media/shopping-cartLight.ae88c279b89a3eecc355755163b2106b.svg";
export { ForwardRef as ReactComponent };